import React from "react";
import ReactDom from "react-dom";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import Filtros from "../components/Filtros";
import Vacante from "../components/Vacante";
import { getMunicipios } from "../requests/req_general";
import { getVacantes } from "../requests/req_ofertas";
import { notifica } from "../requests/utils";
import queryString from "query-string";
import localeInfo from "rc-pagination/lib/locale/es_ES";
import { getCombos } from "../requests/req_general";
import { CardOfertas } from "../components/CardOfertas";


export default class Ofertas extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      js_Vacnts: null,
      showOffer: false,
      pag: 1,
      js_Categoria: null,
      js_Ciudad: null,
      js_TpCntrt: null,
      js_TpJrnd: null,
      vacantes: null,
      idVacante: null,
      idZonificacion: null,
      categr: [],
      contrt: [],
      tpjorn: [],
      estados: null,
      municip: null,
      parameter: null,
      idzon: null,
      idsol: null,
      fltrs: null,
      preguntas: [],
      puesto: "",
    };
    this.childHandler = this.childHandler.bind(this);
    this.ocultaOferta = this.ocultaOferta.bind(this);
    this.mostrarOferta = this.mostrarOferta.bind(this);
    this.buscaVacantes = this.buscaVacantes.bind(this);
    this.generaVacantes = this.generaVacantes.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.generaDivVacantes = this.generaDivVacantes.bind(this);
    this.defineVacantesMostrar = this.defineVacantesMostrar.bind(this);
    this.mostrarOfertaUrl = this.mostrarOfertaUrl.bind(this);
  }

  componentDidMount() {
    getCombos((c) => {
      this.setState({ categr: c.filter((j) => j.combo === "idEspecialidad") });
      this.setState({
        contrt: c.filter((j) => j.combo === "idTipoContratacion"),
      });
      this.setState({ tpjorn: c.filter((j) => j.combo === "idTipoJornada") });
    });

    this._isMounted = true;

    let url = window.location.href;
    if (url != null) {
      let parameters = url.split("?");
      let campos = "";
      let json = "";

      if (url.split("?").length > 1) {
        var key = queryString.parseUrl(url).query;
        if (key.vct != null) {
          localStorage.setItem("vct", key.vct);
        }
      } else {
        if (parameters[1] !== undefined) {
          campos = atob(parameters[1]);
          campos = campos.replace(/{/g, "");
          campos = campos.replace(/:/g, ":");
          campos = campos.replace(/,/g, ",");
          campos = campos.replace(/'/g, "");
          campos = campos.replace(/}/g, "");
          json = campos;

          let idSol = json.split(",")[0].split(":")[1];
          let idZon = json.split(",")[1].split(":")[1];
          if (parseInt(idSol, 10) > 0 && parseInt(idZon, 10) > 0) {
            this.setState({
              showOffer: true,
              idVacante: parseInt(idSol, 10),
              idZonificacion: parseInt(idZon, 10),
            });
          }
        }
      }
    }
    getMunicipios((e) => this.estableceEstados(e));
    this.buscaVacantes();
  }
  componentDidUpdate() {
    if (localStorage.getItem("vct") != null) {
      var encodedString = localStorage.getItem("vct");
      var decodedString = atob(encodedString);
      localStorage.removeItem("vct");
      decodedString = decodedString.replace(/{/g, "");
      decodedString = decodedString.replace(/:/g, ":");
      decodedString = decodedString.replace(/,/g, ",");
      decodedString = decodedString.replace(/'/g, "");
      decodedString = decodedString.replace(/}/g, "");
      var json = decodedString;
      localStorage.removeItem("url");
      let idSol = json.split(",")[0].split(":")[1];
      let idZon = json.split(",")[1].split(":")[1];
      idSol = idSol.replace('"', "");
      idZon = idZon.replace('"', "");
      var item = {
        idSolicitud: idSol != null ? parseInt(idSol, 10) : 0,
        idZonificacion: idZon != null ? parseInt(idZon, 10) : 0,
      };
      this.mostrarOfertaUrl(item);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  estableceEstados(datos) {
    if (datos == null) return;
    if (this._isMounted) {
      var lbl = document.getElementById("lbl_util"),
        js = JSON.parse("{" + lbl.innerText + "}"),
        a = { id: 1, filtro: "Estado", valor: js.idEstado, tipo: "idEstado" },
        b = { id: 2, filtro: "Puesto", valor: js.idPuesto, tipo: "idPuesto" },
        arr = [];
      if (js.idEstado !== undefined) {
        arr.push(a);
      }
      if (js.idPuesto !== undefined) {
        arr.push(b);
      }
      lbl.innerText = "";
      this.setState({ estados: datos, fltrs: arr });
    }
  }
  childHandler(dataFromChild) {
    this.setState(
      {
        data: dataFromChild,
      },
      () => this.buscaVacantes(dataFromChild)
    );
  }
  handlePageChange(e) {
    this.setState({ pag: e });
    this.defineVacantesMostrar(e);
  }
  //Mostrar detalle de la oferta
  mostrarOferta(puesto, e) {
    var elm = e.target,
      idVac = elm.getAttribute("idvacante"),
      splt = idVac.split(",");

    this.setState({
      showOffer: true,
      idVacante: parseInt(splt[0], 10),
      idZonificacion: parseInt(splt[1], 10),
      puesto: puesto,
    });
  }

  mostrarOfertaUrl(data) {
    if (data != null) {
      this.setState({
        showOffer: true,
        idVacante: parseInt(data.idSolicitud, 10),
        idZonificacion: parseInt(data.idZonificacion, 10),
      });
    }
  }
  //Ocultar detalle de la oferta
  ocultaOferta(datoHijo) {
    this.setState({ showOffer: datoHijo });
  }

  //Función que genera Hdr de vacante
  buscaVacantes(js) {
    //let mcps = null;
    if (this._isMounted) {
      if (js !== undefined) {
        var json = JSON.parse(js),
          idEs = json.idEstado;
        if (idEs !== undefined) {
          let mcps = this.state.estados.filter(
            (m) => m.idEstado === parseInt(idEs, 10)
          )[0];
          this.setState({ municip: mcps.municipios });
        }
      }
      //this.setState({ municip: mcps == null ? null : mcps.municipios });
      getVacantes((v) => this.generaDivVacantes(v));
    }
  }

  //Genera el div en el cual se van a colocar las vacantes
  generaDivVacantes(datos) {
    if (this._isMounted) {
      if (datos === null) {
        notifica("warning", "No se encontraron vacantes", "¡Alerta");
        return;
      }
      var d = document.getElementById("ARC_dv_Vacantes"),
        p = document.getElementById("ARC_dv_Paginacion");
      this.setState({ vacantes: datos });
      ReactDom.render(<div>{this.generaVacantes(datos, 1)}</div>, d);
      ReactDom.render(
        <Pagination
          showTotal={(total) => "Total " + total + " vacantes"}
          total={datos.length}
          showLessItems={true}
          onChange={(e) => this.handlePageChange(e)}
          locale={localeInfo}
        />,
        p
      );
    }
  }

  //Función que genera Hdr de vacante
  generaVacantes(datos, pag) {
    if (datos == null) return;
    if (datos.length > 0) {
      var LS = pag * 10,
        LI = LS - 10,
        i = 0,
        arr_vc = [];

      datos.forEach(function (d) {
        if (i >= LI && i < LS) {
          arr_vc.push(d);
        }

        i++;
      });
      return arr_vc.map((d, index) => {
        var imagen =
          d.Imagen !== ""
            ? d.Imagen
            : process.env.PUBLIC_URL + "/images/icon_noimage.png";

        return <CardOfertas _this={this} d={d} index={index} imagen={imagen} />;
      });
    }
  }

  defineVacantesMostrar(p) {
    var d = document.getElementById("ARC_dv_Vacantes");
    ReactDom.unmountComponentAtNode(d);
    ReactDom.render(
      <div>{this.generaVacantes(this.state.vacantes, p)}</div>,
      d
    );
  }

  render() {
    return (
      <div className="ARC_Ofertas " id="dv_Ofertas">
        <div className="ARC_Ofr_Fltrs">
          <Filtros
            action={this.childHandler}
            fdflt={this.state.fltrs}
            estds={this.state.estados}
            muni={this.state.municip}
            cats={this.state.categr}
            cds={this.state.js_Ciudad}
            cntr={this.state.contrt}
            jrnds={this.state.tpjorn}
          />
        </div>

        <Vacante
          mostrar={this.state.showOffer}
          action={this.ocultaOferta}
          vacantes={this.state.vacantes}
          idvac={this.state.idVacante}
          idzon={this.state.idZonificacion}
          puesto={this.state.puesto}
        />

        <div className="ARC_Ofr_Vcnts">
          <div id="ARC_dv_Vacantes" />
          <div id="ARC_dv_Paginacion" />
        </div>
      </div>
    );
  }
}
